import template from './loansRepaymentForm.html';
import controller from './loansRepaymentForm.controller';
import './loansRepaymentForm.scss';

let loansRepaymentFormComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    repaymentType: '<',
    onCreateRepayment: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansRepaymentFormComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentForm/loansRepaymentForm.component.js